import createReactSolidComponent from '../createReactSolidComponent';
export default createReactSolidComponent('letter-t', 'LetterTSolid', [["path",{"d":"M8 6a1 1 0 0 0 0 2h2.75v9a1 1 0 1 0 2 0V8h2.75a1 1 0 1 0 0-2z","key":"svg-0"}]]);